module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_usa.RU.493bf568.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_usa.RU.png
// module id = 1202
// module chunks = 16